import { combineEpics } from "redux-observable";
import { uiEpics } from "src/redux/ui/epics";
import { householdClaimEpics } from "src/redux/claim/household/epics";

export const rootEpic = combineEpics(uiEpics, householdClaimEpics);
